import * as React from "react";
import { graphql } from "react-apollo";

import gql from "graphql-tag";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

import DatePicker from "material-ui/DatePicker";
import handleMutationError from "app/utils/handleMutationError";
let OFFSET = 0;
let LIMIT = 10;

class SettlementBatches extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      limit: LIMIT,
      settlement_batches: [],
      loading: false,
      offset: OFFSET,
      created_at_from: null,
      created_at_to: null
    };

    // FILTER
    this.filterFrom = this.filterFrom.bind(this);
    this.filterTo = this.filterTo.bind(this);

    // PAGINATION
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);

    // DATA LOAD
    this.loadBatches = this.loadBatches.bind(this);

    // MUTATION
    this.submitSettlementBatch = this.submitSettlementBatch.bind(this);
  }

  componentDidMount() {
    this.loadBatches(this.state.created_at_from, this.state.created_at_to, 0);
    this.props.setHeader({
      title: "Settlement Batches",
      description: "SnapScan Settlement Batches"
    });
  }

  loadBatches(createdAtFrom: any, createdAtTo: any, offset: any) {
    this.setState({
      settlement_batches: [],
      loading: true,
      offset: offset,
      created_at_from: createdAtFrom,
      created_at_to: createdAtTo
    });

    this.props.settlement_batches.fetchMore({
      variables: {
        created_at_from: createdAtFrom,
        created_at_to: createdAtTo,
        offset: offset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          settlement_batches: [...fetchMoreResult.settlement_batches],
          loading: false
        });
      }
    });
  }

  goNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadBatches(
      this.state.created_at_from,
      this.state.created_at_to,
      TMP_OFFSET
    );
  }
  goPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadBatches(
      this.state.created_at_from,
      this.state.created_at_to,
      TMP_OFFSET
    );
  }

  filterFrom(event: any, date: any) {
    this.loadBatches(date, this.state.created_at_to, 0);
  }
  filterTo(event: any, date: any) {
    this.loadBatches(this.state.created_at_from, date, 0);
  }

  submitSettlementBatch(id: any) {
    this.props
      .submit_settlement_batch({
        variables: {
          id: id
        }
      })
      .then(({ data }) => {
        this.loadBatches(undefined, undefined, undefined);
      })
      .catch(handleMutationError);
  }

  render() {
    let batchesList =
      this.state.settlement_batches && this.state.settlement_batches.length > 0
        ? this.state.settlement_batches
        : [];

    const statusButton = (status, id) => {
      if (status === "pending") {
        return (
          <Button onClick={() => this.submitSettlementBatch(id)}>Submit</Button>
        );
      } else {
        return null;
      }
    };

    return (
      <section id="Ops_PaymentsList" className="padded">
        <h3
          style={{
            borderBottom: "1px solid rgb(204, 204, 204)",
            fontWeight: 400,
            display: "flex",
            alignItems: "center",
            marginTop: 0
          }}
        >
          <span style={{ marginRight: "10px" }}>Settlement Batches: </span>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start"
            }}
          >
            <DatePicker
              hintText="From"
              onChange={this.filterFrom}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
              textFieldStyle={{
                width: "200px"
              }}
            />
            <DatePicker
              hintText="To"
              onChange={this.filterTo}
              style={{
                width: "200px",
                marginRight: "10px"
              }}
              textFieldStyle={{
                width: "200px"
              }}
            />
          </div>
        </h3>
        <div
          id="setHeight"
          style={{
            height: "calc(100% - 90px)",
            overflow: "auto"
          }}
        >
          <table
            style={{
              width: "100%"
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>ID</th>
                <th>Status</th>
                <th>Comment</th>
              </tr>
            </thead>
            <tbody className={`${this.state.loading ? "hidden" : "shown"}`}>
              {batchesList.map((val, key) => {
                return (
                  <tr key={key}>
                    <td>{val.created_at}</td>
                    <td>
                      <Link
                        className="blueLink"
                        to={`/snapscan/settlements/batches/${val.id}/summary`}
                      >
                        {val.id}
                      </Link>
                    </td>
                    <td>{val.status}</td>
                    <td>
                      {val.comment}
                      {statusButton(val.status, val.id)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={() => this.goPrev()}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          className={
            batchesList.length < LIMIT || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={() => this.goNext()}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </section>
    );
  }
}

// QUERIES
const SettlementBatchesGQ = graphql(
  gql`
    query SettlementBatches(
      $offset: Int
      $limit: Int
      $created_at_from: String
      $created_at_to: String
    ) {
      settlement_batches(
        offset: $offset
        limit: $limit
        created_at_from: $created_at_from
        created_at_to: $created_at_to
      ) {
        created_at
        id
        status
        comment
      }
    }
  `,
  {
    name: "settlement_batches",
    options(props: any) {
      return {
        variables: {
          created_at_from: null,
          created_at_to: null,
          offset: OFFSET,
          limit: LIMIT
        }
      };
    }
  }
);
const releaseSettlement = graphql(
  gql`
    mutation releaseSettlement($id: ID!) {
      submit_settlement_batch(id: $id) {
        created_at
        id
      }
    }
  `,
  {
    name: "submit_settlement_batch"
  }
);

export default SettlementBatchesGQ(releaseSettlement(SettlementBatches));
